import {keys, orderBy} from "lodash";
import {IModuleMetricDefinition} from "../../features/dashboard/api/dashboardModels";
import {
    IClientConceptMetricDefinition,
    IColumnMetadata,
    IDataTableData
} from "../../features/application/api/applicationModels";

const dataTableUtil = {
    mapDataTableData<T>(data: T[]): IDataTableData[] {
        if (!data || data.length === 0) {
            return [];
        }

        const columnKeys = keys(data[0]);
        return data.map((sourceRow) => {
            const targetRow: IDataTableData = {};
            for (let i = 0; i < columnKeys.length; i++) {
                const key = columnKeys[i];
                targetRow[key] = (sourceRow as any)[key];
            }
            return targetRow;
        });
    },

    mapModuleMetricToColumnMetadata(
        metricDefinitions: IModuleMetricDefinition[]
    ): IColumnMetadata[] {
        const columnArray: IColumnMetadata[] = [];
        const sortedMetricDefinitions = orderBy(metricDefinitions, [
            "sortOrder",
            "toggleOrder",
            "metricOrder"
        ]);

        sortedMetricDefinitions.forEach((m) => {
            columnArray.push({
                label: m.metricName,
                key: m.metricCode,
                dataType: m.dataType,
                decimalPlaces: m.decimalPlaces,
                hasFilter: m.hasFilter
            });
        });
        return columnArray;
    },

    mapMetricDefintionToColumnMetadata(
        metricDefinitions: IClientConceptMetricDefinition[]
    ): IColumnMetadata[] {
        const columnArray: IColumnMetadata[] = [];
        metricDefinitions.forEach((m) => {
            columnArray.push({
                label: m.alias,
                key: m.metricCode,
                dataType: m.dataType,
                decimalPlaces: m.decimalPlaces
            });
        });
        return columnArray;
    }
};
export default dataTableUtil;
